import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import News from "../News/News";
import Searchbar from "../Searchbar/Searchbar";
import SendTweetHeader from "./SendTweetHeader";
import Tweet from "./Tweet";
import SimpleSpinner from "../Loader/SimpleSpinner";
import cogoToast from "cogo-toast";
import AllCaughtUp from "../AllCaughtUp/AllCaughtUp";
import { useQuery } from "react-query";
import { getTopTopics } from "../../services/tweetService";
import { pusher } from "../../services/pusherService";
import { queryClient } from "../../CONSTANTS";


export default function TweetSections() {
  const [searchQuery, setSearchQuery] = useState("");
  const bindChannel = (data) => {
    let feed = data;
    const channel = pusher.subscribe("state-topics");
    channel.bind("update-counter", (response) => {
      const i = feed.findIndex((el) => el.id === response.id);
      if (i > -1) {
        feed[i] = response;
        console.log(feed);
        queryClient.setQueryData("feed-tweets", feed);
      }
    });
  };
  const { data: feedTopTopics, isFetching, error } = useQuery(
    "feed-tweets",
    getTopTopics,
    {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      onSuccess: bindChannel,
      staleTime: 0,
    }
  );

  useEffect(() => {
    document.title = `مجلس الشعب  | الصفحة الرئيسية`;
    window.scrollTo(0, 0);
  }, []);

  // const bindChannel = () => {
  //   let feed = feedTopTopics;
  //   const channel = pusher.subscribe("state-topics");
  //   channel.bind("update-counter", (response) => {
  //     const i = feed.findIndex((el) => el.id === response.id);
  //     if (i > -1) {
  //       feed[i] = response;
  //       console.log(feed);
  //       queryClient.setQueryData("feed-tweets", feed);
  //     }
  //   });
  // };

  return (
    <>
      <div className="sidebar searchbar-news-sections hide-on-tablet-up">
        <div className="searchbar-news-sections-wrap">
          <Searchbar
            input={searchQuery}
            setInput={(value) => setSearchQuery(value)}
          />
          <News />
          {/* <WhoToFollow /> */}
        </div>
      </div>
      <div className="tweets-search-news-sections two-flex-col-container">
        <div className="col1 tweet-sections container wrap-input-tweets ">
          <SendTweetHeader />
          {/* <div className="tweet-input-container">
            {width > 500 && <SendTweet />}
          </div> */}
          {/* all magic happens here */}
          <div className="tweets">
            {feedTopTopics &&
              <>
                {/* {bindChannel()} */}
                {feedTopTopics.map((tweet) => (
                  <Tweet tweet={tweet} key={tweet.id} />
                ))}
              </>
            }
            
            {isFetching && (
              <div className="loading-more-tweets">
                <SimpleSpinner topCenter />
              </div>
            )}
            {!isFetching && feedTopTopics && feedTopTopics.length === 0 && (
              <AllCaughtUp />
            )}
            {error && cogoToast.error(error)}
          </div>
        </div>
        <div className="col2 sidebar searchbar-news-sections ">
          <div className="searchbar-news-sections-wrap">
            <Searchbar
              input={searchQuery}
              setInput={(value) => setSearchQuery(value)}
            />
            <News />
          </div>
        </div>
      </div>

      <Outlet />
    </>
  );
}